module.exports = __webpack_public_path__ + "media/images/slides/poor_poet-24d4cbec5c4e256fae751506a8384e13.jpg";